import {getMethod, patchMethod, postMethod, putMethod} from '~/api'

async function get(body) {
    return await getMethod('/api/kpis', body)
}

async function post(request) {
    return await postMethod('/api/kpi', request)
}

async function put(id, request) {
    return await putMethod(`/api/kpi/${id}`, request)
}

async function patch(id, request) {
    return await patchMethod(`/api/kpi/${id}`, request)
}

export {post, get, put, patch}
